import React, { useState, useEffect } from "react";
import "./ModalB.css";
import ReactModal from "react-modal";
import Button from "../shared/Button/Button";

const ModalB = ({
  open,
  msj,
  close,
  buttons,
  funct,
  funct2,
  icon,
  btn1,
  txt,
  opacity,
}) => {
  const [openM, setOpen] = useState();

  useEffect(() => {
    setOpen(open);
  }, [open]);

  return (
    <ReactModal
      onRequestClose={close}
      appElement={document.querySelector(".App")}
      isOpen={openM}
      className="modal modal-dialog-centered"
      tabIndex="-1"
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, .5)",
        },
      }}
    >
      <div className="modal-dialog">
        <div className="modal-content modal2">
          <div className="modal-header mhdr2">
            <button
              type="button"
              className="btn-close close-modal"
              onClick={close}
            ></button>
          </div>
          <div className="modal-body mbdy2">
            <div className="text-center">
              <i className={icon}></i>
              <p className="modal-text-m2">{msj}</p>

              {txt && txt}

              {buttons && (
                <div
                  className={`m-button-wrapper ${
                    txt && opacity ? "opacity-btns" : ""
                  }`}
                >
                  <Button
                    text={btn1}
                    myClass={"btn btn-dark rounded-pill btn-ch btn-camb mb-2"}
                    funct={funct}
                  />
                  <Button
                    text={"cancelar"}
                    myClass={"btn btn-outline-dark btn-c rounded-pill"}
                    funct={funct2}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

export default ModalB;
